import { put, takeEvery, select, all, race } from 'redux-saga/effects';
import { path, mergeAll } from 'ramda';
import {
  patientEngagementInitStatusesPage,
  requestGetPatientStatusesById,
  patientEngagementSetStatusesWithPatientId,
} from 'store/actionCreators/patientEngagement';

import { requestResources, requestResourcesFaq } from 'store/actionCreators/resources';

import { createSagaRequestRace } from 'utilities/request';

import { isResources } from 'store/selectors/resources';

export function* onGetPatientsStatuses({ payload: { patientId } }) {
  yield put(requestGetPatientStatusesById({ patientId }));

  const isDocuments = yield select(isResources);
  if (!isDocuments) {
    yield put(requestResources());
    yield put(requestResourcesFaq({ lang: 'en' }));
  }

  const { getStatuses } = yield all(
    mergeAll([
      isDocuments ? null : { getResources: race(createSagaRequestRace(requestResources)) },
      isDocuments ? null : { getFaq: race(createSagaRequestRace(requestResourcesFaq)) },
      { getStatuses: race(createSagaRequestRace(requestGetPatientStatusesById)) },
    ]),
  );

  if (getStatuses.success) {
    yield put(
      patientEngagementSetStatusesWithPatientId({
        statuses: path(['payload', 'response'])(getStatuses.success),
        currentPatient: patientId,
      }),
    );
  }
}

export default function*() {
  yield takeEvery(patientEngagementInitStatusesPage, onGetPatientsStatuses);
}
